var map = {
	"./ar.json": 890,
	"./de.json": 891,
	"./en.json": 892,
	"./es.json": 893,
	"./fr.json": 894,
	"./it.json": 895,
	"./ja.json": 896,
	"./nl.json": 897,
	"./pt.json": 898,
	"./zh.json": 899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;